(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"]) return;
  try {
    
(function () {
  function bindSeoToggles() {
    document.querySelectorAll('[data-ajluxe-seo-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-ajluxe-seo-bound') === '1') {
        return;
      }
      btn.setAttribute('data-ajluxe-seo-bound', '1');
      btn.addEventListener('click', function () {
        var root = btn.closest('[data-ajluxe-seo]');
        if (!root) {
          return;
        }
        var full = root.querySelector('.ajluxe-collection-seo__full');
        var preview = root.querySelector('.ajluxe-collection-seo__preview');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var more = btn.getAttribute('data-label-more') || 'Read more';
        var less = btn.getAttribute('data-label-less') || 'Read less';
        if (expanded) {
          if (full) {
            full.setAttribute('hidden', '');
            full.classList.add('is-collapsed');
          }
          if (preview) {
            preview.removeAttribute('hidden');
          }
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = more;
        } else {
          if (full) {
            full.removeAttribute('hidden');
            full.classList.remove('is-collapsed');
          }
          if (preview) {
            preview.setAttribute('hidden', '');
          }
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = less;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSeoToggles);
  } else {
    bindSeoToggles();
  }
  document.addEventListener('shopify:section:load', bindSeoToggles);
})();

  } catch(e) { console.error(e); }
})();
})();
